export default __webpack_public_path__ + "static/media/secret_pay.e4f35df3.svg";